<template>
  <div class="autocomplete-container">
		<input style="width:100%;padding:0.3rem;" :value="value" @input="$emit('input', $event.target.value)">
		<div class="autocomplete-suggest-box" v-if="value.length > 0 && show">
			<div><p v-for="item in items" :key="item.id" class="autocomplete-suggest-item" @click="OnSelect(item)">{{item.name}}</p></div>
		</div>
	</div>
</template>

<script>
import { Http } from '../core/digitify.js'

export default {
  props: {
		value:String,
		endpoint:String,
		tag:String,
		filterItems:{type:Array, default: function () { return [] }},
	},
	data() {
		return {
			items:[],
			selectedItems:[],
			show: false
		}
	},
	methods: {
		Reload: function() {
			Http.Request(
				'GET', this.endpoint, {
				  data: {key:this.tag, operator:'LIKE', value: this.value},
				  OnResponse:function(json) {
					  this.show = true;
					  this.items = json.filter(function(kv) {
						var included = true;
						for(var i = 0; i < this.filterItems.length; ++i) {
							if (kv.id == this.filterItems[i].id) {
								included = false;
								break;
							}
						}
						return included;
					  }.bind(this));
				  }.bind(this)
				}
			);
		},
		OnSelect: function(item) {
			this.$emit('input', item.name);
			this.$emit('OnSelected', item);
			this.show = false;
		}
	},
	watch: {
		'value' : {
			handler(n) {
				if (n.length === 0) { return; }
				for (var i = 0; i < this.items.length; ++i) {
					if (this.items[i].name == n) { return; }
				}
				this.items = [];
				this.Reload();
			}
		}
	}
}
</script>

<style scoped>
.autocomplete-container{
  padding:0;
  position: relative;
}
.autocomplete-suggest-box{
  position: absolute;
  z-index:1;
  padding: 0px;
  background-color:white;
  border:0px solid;
  box-shadow: 1px 1px 1px 1px #888888;
  padding: 5px;
  width: 100%;
}
.autocomplete-suggest-item{
  margin-bottom: 4px;
  font-weight: bold;
  cursor: pointer;
}
.autocomplete-suggest-item:hover{
  background: #dedede;
  padding: 3px;
}
</style>
